// 繁體中文翻譯
export const zhTW = {
  common: {
    settings: '設定',
    refresh: '重新整理',
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    edit: '編輯',
    close: '關閉',
    confirm: '確認',
    loading: '載入中...',
    online: '在線',
    offline: '離線',
    unknown: '未知',
    yes: '是',
    no: '否',
    search: '搜尋',
    filter: '篩選',
    export: '匯出',
    import: '匯入',
    enable: '啟用',
    disable: '停用',
    enabled: '已啟用',
    disabled: '已停用',
    apply: '套用',
    reset: '重置',
    clear: '清除',
    all: '全部',
    none: '無',
    select: '選擇',
    selected: '已選擇',
    add: '新增',
    remove: '移除',
    update: '更新',
    create: '建立',
    view: '檢視',
    details: '詳細資訊',
    name: '名稱',
    type: '類型',
    status: '狀態',
    actions: '動作',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    finish: '完成',
    copy: '複製',
    copied: '已複製',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    info: '資訊',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',

    // Theme
    lightMode: '淺色模式',
    darkMode: '深色模式',
  },

  sidebar: {
    dashboard: '總覽',
    powerMeterView: '電表視圖',
    energy: '能源監控',
    climate: '環境監控',
    hvac: 'HVAC 控制',
    lighting: '照明控制',
    intelliSpace: 'IntelliSpace',
    alerts: '警報管理',
    deviceLogs: '設備日誌',
    generateReport: '報表產生',
    settings: '系統設定',
    devices: '設備管理',
    home: '首頁',
    energyBoard: '能源儀表板',
    climateBoard: '環境儀表板',
    hvacBoard: 'HVAC 儀表板',
    lightingBoard: '照明儀表板',
    intelliSpaceBoard: 'IntelliSpace 智能空間',
    apiKeySettings: 'API 金鑰設定',
  },

  dashboard: {
    // 標題
    title: '能源監控儀表板',
    energyMonitoring: '能源監控',
    realTimePower: '即時功率監控',

    // 指標
    power: '功率',
    voltage: '電壓',
    current: '電流',
    energy: '能耗',
    powerFactor: '功率因數',
    frequency: '頻率',

    // 單位
    watt: 'W',
    kilowatt: 'kW',
    volt: 'V',
    ampere: 'A',
    kilowattHour: 'kWh',
    hertz: 'Hz',

    // 狀態
    totalPower: '總功率',
    totalEnergy: '總能耗',
    todaysEnergy: '今日能耗',
    estimatedCost: '預估費用',
    deviceCount: '設備數量',
    devices: '設備',
    onlineDevices: '在線設備',
    offlineDevices: '離線設備',
    powerMeters: '電錶',

    // 動作
    importDevices: '匯入設備',
    manageDevices: '管理設備',
    refreshData: '重新整理數據',
    exportData: '匯出數據',

    // 時間
    lastUpdate: '最後更新',
    autoRefresh: '自動重新整理',
    refreshInterval: '重新整理間隔',

    // 圖表
    powerChart: '功率圖表',
    energyChart: '能耗圖表',
    trend: '趨勢',
    history: '歷史記錄',

    // 訊息
    noDevices: '尚無設備',
    noData: '無數據',
    loadingData: '載入數據中...',
    selectDevices: '請選擇設備',

    // 卡片
    clickToViewChart: 'Click to view detailed chart',
    deviceOffline: 'Device Offline',
    noDataAvailable: 'No Data Available',

    // Device Manager
    deviceManager: '設備管理器',
    importedDevices: '已匯入設備',
    availableDevices: '可用設備',
    selectAll: '全選',
    deselectAll: '取消全選',
    removeSelected: '移除已選設備',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
    buildDate: '建置日期',
    lastRefreshed: '最後重新整理',

    // Overview Dashboard (新綜合儀表板)
    overviewTitle: 'BUILDING ENERGY MANAGEMENT SYSTEM',
    realTimeLoad: '即時負載',
    totalLoad: '總負載',
    highLoad: '高負載',
    mediumLoad: '中等負載',
    lowLoad: '低負載',
    vsYesterday: '較昨日',
    dailyTrend: '每日趨勢與比較',
    today: '今日',
    yesterday: '昨日',
    todayAccumulated: '今日累計',
    dailyTarget: '每日目標',
    energyBreakdown: '能源分解與可持續性',
    hvac: '空調',
    lighting: '照明',
    plugsOthers: '插座/其他',
    carbonEmissions: '今日碳排放',
    equivalentTrees: '等效植樹',
    climateSummary: '環境監控摘要',
    avgTemperature: '平均溫度',
    minTemperature: '最低溫度',
    maxTemperature: '最高溫度',
    avgHumidity: '平均濕度',
    minHumidity: '最低濕度',
    maxHumidity: '最高濕度',
    totalDevices: '總設備數',
    onlineDevicesCount: '在線設備數',
    fullscreen: '全畫面',
    exitFullscreen: '退出全畫面',
  },

  climate: {
    // 頁面標題
    title: '智慧溫溼度監測中心',
    titleEn: 'Climate Monitoring Center',
    environmentMonitoring: '環境監控',

    // 狀態標籤
    demoMode: 'DEMO MODE',
    lastUpdate: 'Last update:',
    auto: '自動',
    manual: '手動',
    alertCenter: 'Alert Center',

    // 統計摘要
    avgTemp: 'Avg Temp',
    avgHumidity: 'Avg Humidity',
    tempRange: 'Temp Range',
    humidityRange: 'Humidity Range',
    devices: 'Devices',

    // 載入狀態
    loading: '載入氣候裝置中...',

    // 錯誤訊息
    noDevicesImported: 'No devices imported. Please go to Device Manager to import devices.',
    loadError: 'Failed to load climate devices. Please check your connection and try again.',
    tryAgain: 'Try Again',

    // 空白狀態
    noSensorsFound: 'No climate sensors found',
    configureDevices: 'Please configure your climate devices in Settings',
    goToSettings: 'Go to Settings',

    // 頁尾
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',

    // 指標
    temperature: '溫度',
    humidity: '濕度',
    co2: 'CO2',
    tvoc: 'TVOC',
    pm25: 'PM2.5',
    illuminance: '照度',
    pressure: '氣壓',

    // 單位
    celsius: '°C',
    fahrenheit: '°F',
    percent: '%',
    ppm: 'ppm',
    lux: 'lux',
    hPa: 'hPa',

    // 狀態
    comfortable: '舒適',
    good: '良好',
    moderate: '普通',
    poor: '差',
    veryPoor: '很差',

    // 感測器類型
    temperatureSensor: '溫度感測器',
    humiditySensor: '濕度感測器',
    co2Sensor: 'CO2 感測器',
    airQualitySensor: '空氣品質感測器',

    // 訊息
    noSensors: '尚無感測器',
    sensorOffline: '感測器離線',

    // 卡片
    temp: 'Temp',
    humi: 'Humi',
    clickToViewHistory: 'Click to view historical data',
  },

  alerts: {
    title: '警報管理',
    alertManagement: '警報管理',

    // 警報類型
    critical: '嚴重',
    warning: '警告',
    info: '資訊',

    // 警報狀態
    active: '啟用中',
    acknowledged: '已確認',
    resolved: '已解決',

    // 動作
    acknowledge: '確認',
    resolve: '解決',
    mute: '靜音',
    unmute: '取消靜音',

    // 設定
    alertRules: '警報規則',
    createAlert: '建立警報',
    newAlert: '新增警報',
    createNewAlert: '建立新警報',
    createFirstAlert: '建立您的第一個警報',
    editAlert: '編輯警報',
    updateAlert: '更新警報',
    deleteAlert: '刪除警報',
    testAlert: '測試警報',
    alertName: '警報名稱',

    // UI 操作
    back: '返回',
    loadingAlerts: '載入警報中...',
    noAlertsConfigured: '尚未配置警報',
    enable: '啟用',
    disable: '停用',
    edit: '編輯',
    delete: '刪除',
    deleteConfirm: '確認刪除',
    cancel: '取消',

    // 條件
    condition: '條件',
    threshold: '閾值',
    above: '高於',
    below: '低於',
    equals: '等於',
    greaterOrEqual: '大於或等於',
    lessOrEqual: '小於或等於',

    // 表單欄位
    device: '設備',
    selectDevice: '選擇設備',
    selectDeviceFirst: '請先選擇設備',
    noMetricsAvailable: '無可用指標',
    metric: '指標',
    temperature: '溫度',
    humidity: '濕度',
    battery: '電池',
    presence: '人員偵測',
    detected: '有人',
    notDetected: '無人',
    voltage: '電壓',
    current: '電流',
    power: '即時功率',
    energy: '累計用電',
    powerState: '設備狀態',
    onlineStatus: '在線狀態',
    lux: '照度',

    // 狀態條件
    on: '開啟',
    off: '關閉',
    changed: '狀態變化',
    online: '在線',
    offline: '離線',

    thresholdValue: '閾值',
    severityLevel: '嚴重程度',
    major: '重要',

    // 通知
    notification: '通知',
    notificationChannels: '通知管道',
    websocket: 'WebSocket',
    line: 'LINE',
    email: 'Email',
    browserWebSocket: '瀏覽器 (WebSocket)',
    toastNotification: '應用程式內通知 (Toast)',
    systemNotification: '系統通知 (需授權)',
    lineNotify: 'LINE 通知',

    // 觸發模式
    triggerMode: '觸發模式',
    edgeTrigger: '邊緣觸發',
    continuous: '持續監看',
    intervalReminder: '間隔提醒',
    edgeTriggerDesc: '只在穿越閾值時通知，狀態改變時發送恢復通知',
    continuousDesc: '每次檢查都通知（適合關鍵警報）',
    intervalReminderDesc: '每 N 分鐘提醒一次（避免通知轟炸）',

    // 時間單位
    minutes: '分鐘',
    hour: '小時',
    hours: '小時',
    onceDaily: '每日一次（每 24 小時）',

    // 電池警報
    batteryAlert: '電池警報',
    lowBattery: '電池電量低',
    batteryLevel: '電池電量',
    batteryThreshold: '電池閾值',
    
    // 門窗/移動感應
    doorState: '門窗狀態',
    motion: '移動感應',
    opened: '開啟',
    closed: '關閉',
    
    // 窗簾/捲簾
    curtain: '窗簾',
    blind: '捲簾',
    rollerShade: '捲簾',
    openPercent: '開啟程度',
    fullyOpen: '全開',
    fullyClosed: '全關',
  },

  hvac: {
    // 頁面標題
    title: '智慧空調監控中心',
    titleEn: 'HVAC Control Center',

    // 狀態標籤
    ultronTuring: 'Ultron Turing',
    demoMode: 'DEMO MODE',
    lastUpdate: '上次更新',
    auto: '自動',
    manual: '手動',
    alertCenter: '警報中心',

    // 統計摘要
    totalUnits: '總數',
    active: '運行中',
    avgTemp: '平均溫度',
    ai: 'AI',
    learning: '學習中',
    aiActive: '已啟用',
    off: '關閉',
    status: '狀態',

    // 設備類型
    thSensor: '溫濕度感測器',
    presenceSensor: '人體感應感測器',
    presenceLuxSensor: '人體感應 & 照度感測器',
    offline: 'OFFLINE',

    // 拖曳
    dragToReorder: '拖曳調整順序',

    // 模式
    cool: '冷氣',
    heat: '暖氣',
    fan: '送風',
    fanOnly: '送風',
    dry: '除濕',
    normal: '一般',
    natural: '自然風',
    sleep: '睡眠',

    // 風速
    speed: '速度',
    low: '低速',
    medium: '中速',
    high: '高速',

    // 溫度
    set: '設定',

    // 空白狀態
    noDevicesFound: '找不到 HVAC 設備',
    noDevicesConfigured: '系統中尚未設定任何空調設備。',

    // 載入中
    loadingDevices: '載入 HVAC 設備中...',

    // 通知訊息
    noDevicesImported: '尚未匯入設備。請前往設備管理器匯入設備。',
    devicesFound: '找到 {{count}} 個 HVAC 設備',
    failedToLoad: '無法載入 HVAC 設備',

    // AI 提示
    aiAppliedTo: 'AI 已套用於',
    aiNotEnabled: 'AI 未啟用',

    // 頁尾
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
  },

  lighting: {
    // 頁面標題
    title: '智慧照明控制中心',
    titleEn: 'Lighting AI Controller',

    // 狀態標籤
    realtime: '即時',
    auto: '自動',
    manual: '手動',

    // 工具提示
    wsConnected: 'WebSocket 已連線 - {count} 個裝置已訂閱',
    wsConnecting: 'WebSocket 連線中 - {count} 個裝置等待中',
    autoRefreshOn: '自動重新整理已開啟',
    autoRefreshOff: '自動重新整理已關閉',
    manualRefresh: '手動重新整理',
    notifications: '通知',

    // 通知訊息
    refreshing: '正在重新整理照明資料...',

    // 統計摘要
    totalUnits: '總數',
    active: '運行中',
    avgBrightness: '平均亮度',
    online: '在線',

    // 載入狀態
    loading: '載入照明裝置中...',

    // 空白狀態
    noDevices: '沒有照明裝置',
    noDevicesDesc: '匯入您的照明裝置和感測器以開始控制它們',
    importDevices: '匯入裝置',

    // 頁尾
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
  },

  settings: {
    title: '設定',

    // 區塊標題
    company: '公司資訊',
    dashboard: '儀表板設定',
    deviceCategorization: '設備分類',
    notification: '系統通知',
    cache: '快取管理',
    language: '語言設定',
    themes: '主題樣式',

    // 主題樣式編輯器
    themesTitle: '設備彈窗主題樣式',
    themesDescription: '為不同類型的設備自訂彈窗外觀',
    templateName: '樣式名稱',
    internalId: '內部 ID',
    statusIndicator: '狀態指示器',
    sensorDisplay: '感應器顯示',
    sensorChart: '感應器圖表',
    occupancyTimeline: '占用時間軸',
    deviceIcon: '設備圖標',
    mainIcon: '大圖標',
    controlStyles: '控制元件樣式',
    dragToReorder: '可拖動調整順序',
    resetDefault: '恢復預設值',
    saveAs: '另存新檔',
    saveAndApply: '儲存並套用',
    livePreview: '即時預覽',
    currentlyApplied: '目前套用',
    editTemplate: '編輯樣式',
    applyTemplate: '套用',
    applied: '已套用',

    // 公司資訊
    companyInfo: '公司資訊',
    logo: '公司 Logo',
    favicon: '網站圖示',
    companyName: '公司名稱',
    currentLogo: '目前的 Logo',
    uploadLogo: '上傳 Logo',
    uploadNewLogo: '上傳新的 Logo',
    uploadFavicon: '上傳 Favicon',
    removeLogo: '移除 Logo',
    removeFavicon: '移除 Favicon',
    currentFavicon: '目前的 Favicon',
    uploadNewFavicon: '上傳新的 Favicon',
    chooseFile: '選擇檔案',
    uploading: '上傳中...',
    logoFileFormats: 'JPG 或 PNG，任何長寬比，自動調整大小',
    faviconLabel: '網站圖示（瀏覽器分頁圖示）',
    faviconFileFormats: 'JPG、PNG 或 ICO，自動調整為 32x32',

    // 儀表板設定
    dashboardSettings: '儀表板設定',
    theme: '主題',
    light: '淺色',
    dark: '深色',
    timezone: '時區',
    selectTimezone: '選擇時區',
    timezoneNote: '時區設定用於正確顯示和計算用電時段',
    refreshInterval: '重新整理間隔',
    gridCardRefreshInterval: '儀表板網格卡片自動重新整理間隔',
    chartRefreshInterval: '資料圖表自動重新整理間隔',
    seconds: '秒',
    minutes: '分鐘',
    hour: '小時',
    recommended: '（推薦）',
    autoRefresh: '自動重新整理',

    // 語言設定
    selectLanguage: '選擇語言',
    currentLanguage: '目前語言',
    traditionalChinese: '繁體中文',
    english: 'English',

    // 系統通知
    systemNotifications: '系統通知',
    lowBatteryNotification: '低電量通知',
    batteryAlert: '電池警報',
    batteryAlertEnabled: '電池警報已啟用',
    batteryAlertDisabled: '電池警報已停用',
    batteryMonitorDescription: '監測所有匯入的帶電池設備，並在電池電量低於閾值時接收每日警報。',
    batteryDevicesFound: '找到的電池設備：',
    batteryStatus: '電池狀態',
    batteryDevicesNote: '所有具有電池功能的設備都將自動被監控',
    batteryThreshold: '電池閾值',
    batteryThresholdPercent: '電池閾值（%）',
    batteryThresholdNote: '當電池電量低於此百分比時發出警報（5-50%）',
    saveConfiguration: '儲存配置',
    testAlert: '測試警報',
    testAlertSuccess: '測試警報已發送',
    alertCenterNote: '警報會顯示在警報中心和提示通知中。所有帶電池的設備都會自動監控。',

    // 系統通知設定
    notificationSettings: '系統通知設定',
    notificationSettingsDescription: '設定不同類型通知的接收方式',
    alertNotification: '警報通知',
    automationNotification: '自動化通知',
    batteryNotification: '電池通知',
    websocketNotification: '網頁通知',
    emailNotification: '電子郵件',
    useCustomEmailAddress: '使用其他郵件地址',
    saveNotificationSettings: '儲存通知設定',
    testEmail: '發送測試郵件',
    testEmailSuccess: '測試郵件已發送，請檢查您的郵箱',
    testEmailFailed: '發送測試郵件失敗',
    noEmailConfigured: '請先設定郵件地址',

    // 快取管理
    cacheManagement: '快取管理',
    cacheManagementDescription: '如果遇到問題，清除快取數據以釋放瀏覽器儲存空間。',
    clearCache: '清除快取',
    clearIncrementalData: '清除增量數據',
    clearAllCache: '清除所有快取',
    clearAllData: '清除所有數據',
    confirmClear: '確認要清除所有快取數據嗎？',
    confirmClearIncrementalData: '這將清除所有增量感測器數據快取。繼續嗎？',
    confirmClearAllCache: '這將清除除設定外的所有快取數據。繼續嗎？',
    cacheCleared: '快取已清除',
    clearedIncrementalCaches: '已清除 {count} 個增量數據快取',
    clearedCacheItems: '已清除 {count} 個快取項目',
    storageUsed: '已使用儲存空間：',

    // 設備分類
    deviceCategorizationTitle: '設備分類設定',
    deviceCategorizationDescription: '為每個設備指定所屬類別，用於綜合儀表板的數據聚合和顯示。',
    deviceCategory: '設備類別',
    selectCategory: '選擇類別',
    categoryEnergy: '能源',
    categoryClimate: '環境',
    categoryHVAC: 'HVAC',
    categoryLighting: '照明',
    deviceName: '設備名稱',
    deviceSN: '設備序號',
    currentCategory: '目前類別',
    autoDetected: '自動判斷',
    resetToDefault: '重置為預設值',
    saveCategories: '儲存分類',
    categoriesSaved: '設備分類已儲存',
    categoriesSaveFailed: '儲存設備分類失敗',
    noDevicesAvailable: '尚無可用設備，請先匯入設備',
    loadingDevices: '載入設備中...',

    // 認證
    authentication: '認證設定',
    authMode: '認證模式',
    oauth: 'OAuth 2.0',
    apiKey: 'API Key',
    appId: 'App ID',
    groupId: 'Group ID',
    credentials: '認證憑證',

    // 訊息
    saveSuccess: '設定已儲存',
    saveFailed: '儲存失敗',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
  },

  deviceModal: {
    title: '設備詳細資訊',
    deviceInfo: '設備資訊',
    deviceName: '設備名稱',
    deviceId: '設備 ID',
    deviceSN: '設備序號',
    deviceType: '設備類型',
    location: '位置',

    // 編輯名稱
    editName: '編輯名稱',
    saveName: '儲存名稱',
    deviceNameCannotBeEmpty: '設備名稱不能為空',
    saveNameFailed: '儲存名稱失敗',

    // 狀態
    status: '狀態',
    online: '在線',
    offline: '離線',
    lastSeen: '最後上線',

    // 控制
    controls: '控制',
    powerOn: '開啟',
    powerOff: '關閉',

    // 資料
    currentData: '當前數據',
    historicalData: '歷史數據',

    // Sensor Modal
    sensorData: '感測器數據',
    realTimeData: '即時數據',
    occupancy: '占用狀態',
    occupied: '有人',
    vacant: '無人',
    motion: '移動偵測',
    detected: '偵測到',
    notDetected: '未偵測到',

    // Light Control Modal
    lightControl: '燈光控制',
    brightness: '亮度',
    colorTemp: '色溫',
    warmWhite: '暖白',
    coolWhite: '冷白',
    rgb: 'RGB 顏色',
    presets: '預設',

    // Power Control
    deviceControl: '設備控制',
    turnOn: '開啟設備',
    turnOff: '關閉設備',
  },

  // 設備詳細 Modal (三相電錶和最大電流設定)
  deviceDetail: {
    totalPhase: '總表',
    threePhaseDetails: 'R/S/T 三相詳細',
    phaseR: 'R 相',
    phaseS: 'S 相',
    phaseT: 'T 相',
    realTimeData: '即時數據',
    maxCurrentSetting: '最大電流設定',
    maxCurrentHint: '設定最大電流限制，用於負載監控和超載警示',
    maxCurrentPlaceholder: '輸入最大電流 (A)',
    maxCurrentMustBePositive: '最大電流必須是大於 0 的數字',
    saveMaxCurrentFailed: '儲存最大電流失敗，請重試。',
    overloadWarning: '負載超限警告',
    overloadMessage: '當前電流超過設定的最大電流限制',
    notSet: '未設定',
    edit: '編輯',
    clear: '清除',
  },

  groupSelector: {
    selectGroup: '選擇群組',
    currentGroup: '當前群組',
    switchGroup: '切換群組',
    loadingGroups: '載入群組中...',
    noGroups: '無可用群組',
  },

  errors: {
    // 通用錯誤
    generalError: '發生錯誤',
    networkError: '網路錯誤',
    serverError: '伺服器錯誤',
    authError: '認證錯誤',
    permissionDenied: '權限不足',
    notFound: '找不到資源',
    timeout: '請求逾時',

    // API 錯誤
    apiCallFailed: 'API 調用失敗',
    invalidResponse: '無效的回應',
    invalidData: '無效的數據',

    // 設備錯誤
    deviceNotFound: '找不到設備',
    deviceOffline: '設備離線',
    deviceControlFailed: '設備控制失敗',

    // 資料錯誤
    loadDataFailed: '載入數據失敗',
    saveDataFailed: '儲存數據失敗',
    deleteDataFailed: '刪除數據失敗',

    // 驗證錯誤
    invalidInput: '無效的輸入',
    requiredField: '此欄位為必填',
    invalidFormat: '格式不正確',

    // 請重試
    pleaseTryAgain: '請重試',
    retryLater: '請稍後再試',
  },

  time: {
    // 星期
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',

    // 月份
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',

    // 相對時間
    now: '現在',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    thisWeek: '本週',
    lastWeek: '上週',
    nextWeek: '下週',
    thisMonth: '本月',
    lastMonth: '上月',
    nextMonth: '下月',

    // 時間單位
    seconds: '秒',
    minutes: '分鐘',
    hours: '小時',
    days: '天',
    weeks: '週',
    months: '月',
    years: '年',

    // 時間格式
    ago: '前',
    later: '後',
  },

  // IntelliSpace
  intelliSpace: {
    title: 'IntelliSpace',
    boardName: '智能空間管理 - 你唯一需要的 Dashboard',
    overview: '總覽',
    control: '控制',
    deviceManager: '設備管理',
    automation: '自動化',
    
    // Overview
    totalDevices: '總設備數',
    totalPower: '總功率',
    avgTemp: '平均溫度',
    avgHumidity: '平均濕度',
    occupancy: '佔用率',
    activeHvac: '運行空調',
    activeSwitches: '開啟開關',
    switchControl: '開關控制',
    
    // Device Types
    powerMeters: '電錶',
    thSensors: '溫濕度感測器',
    presenceSensors: '人體感測器',
    hvacUnits: '空調設備',
    switches: '開關',
    meters: '電錶',
    sensors: '感測器',
    
    // Status
    occupied: '有人',
    vacant: '無人',
    running: '運行中',
    noHvac: '無空調',
    noSensors: '無感測器',
    noSwitches: '沒有開關',
    noPowerMeters: '沒有電錶',
    
    // Selector Modals
    selectPowerMeters: '選擇電錶',
    selectSwitches: '選擇開關',
    selectHvac: '選擇空調',
    selectAll: '全選',
    clearSelection: '清除選擇',
    allMetersIncluded: '包含所有電錶',
    allSwitchesIncluded: '包含所有開關',
    allHvacIncluded: '包含所有空調',
    turnAllOn: '全部開啟',
    turnAllOff: '全部關閉',
    
    // Charts
    todayPowerConsumption: '本日用電曲線',
    todayClimate: '本日溫濕度曲線',
    metersSelected: '電錶已選',
    timeRange: '時間範圍',
    currentPower: '當前功率',
    
    // Automation
    automationTitle: '自動化規則',
    automationDescription: '建立自動化規則，根據時間、佔用狀態或感測器數據來控制您的設備。',
    createRule: '建立規則',
    
    // Messages
    noDevicesImported: '尚未匯入設備。請前往設備管理器匯入設備。',
    loadError: '載入設備失敗，請檢查連線並重試。',
    loading: '載入設備中...',
    noDevices: '找不到設備',
    importDevicesHint: '請前往設備管理器匯入設備',
    openDeviceManager: '開啟設備管理器',
    
    // Empty State
    welcomeTitle: '歡迎使用 IntelliSpace',
    noDevicesDescription: '您尚未匯入任何設備。\n請前往設備管理器選擇並匯入您想要監控的設備。',
    featureClimate: '溫濕度監控',
    featurePower: '用電分析',
    featureHvac: '空調控制',
    goToDeviceManager: '前往設備管理器',
    or: '或',
    refreshDevices: '重新整理',
    today: '今日',
    yesterday: '昨日',
    lastWeek: '上周',
    dailyComparison: '每日趨勢與比較',
  },

  // Power Consumption 24H
  power24h: {
    title: '即時用電',
    subtitle: '時區: {{timezone}}',
    total: '總用電量',
    hvac: '空調用電',
    lighting: '照明用電',
    limit: '上限',
    setLimit: '設定上限',
    limitValue: '上限值',
    noLimitPlaceholder: '留空表示無上限',
    limitHint: '超過 80% 時圖表會變紅色警示',
    noDevice: '未選擇',
    allDevices: '全部',
    devices: '個電錶',
    selectAll: '全選',
    clear: '清除',
    noPowerMeters: '無可用電錶',
    settings: '設定',
    deviceSelection: '電錶選擇',
    limitSettings: '用電上限',
    selectDevices: '選擇電錶',
    vsYesterday: '較昨日',
    vsLastWeek: '較上週',
    vsLastMonth: '較上月',
    summary: '用電摘要',
    totalEnergy: '總用電量',
    averageEnergy: '平均用電',
    peakTime: '峰值時間',
    peakPower: '峰值功率',
    // 三相電錶
    threePhase: '三相',
    phaseR: 'R 相',
    phaseS: 'S 相',
    phaseT: 'T 相',
    totalPhase: '總表',
    power: '功率',
    voltage: '電壓',
    current: '電流',
  },
};

export type TranslationKey = typeof zhTW;
